














import { Component, Vue, Watch } from 'vue-property-decorator'
// import ThePtc from './ThePtc.vue'
import ThePtc from '@core/components/ThePtc.vue'
import TheKycConfirmation from './TheKycConfirmation.vue'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import { namespace } from 'vuex-class'

const kycFormStore = namespace('KYCFormStore')
const kycSubmissionStore = namespace('KYCSubmissionStore')

@Component({
  components: {
    ThePtc,
    TheKycConfirmation
  }
})
export default class KycConfirmation extends Vue {
  @kycFormStore.State
  private kycForm!: KYCForm;

  @kycFormStore.State
  private loadingState!: 'loading' | 'loaded';

  @kycSubmissionStore.Getter
  getPTCChecklist

  @kycSubmissionStore.Getter
  isPTCVerified

  @kycSubmissionStore.Getter
  isSuperiorVerified

  @kycSubmissionStore.Action
  updateKycPDF!: () => void

  private currentTab: 'ptc' | 'confirmation' = 'ptc';

  get activeName (): 'ptc' | 'confirmation' {
    return this.currentTab
  }

  set activeName (activeName: 'ptc' | 'confirmation') {
    this.currentTab = activeName
  }

  @Watch('isPTCVerified')
  onPTCVerifiedChanged (newResult: boolean) {
    if (newResult && this.loadingState === 'loaded') {
      this.currentTab = 'confirmation'
    }
  }

  get isConfirmationVerified () {
    return this.isSuperiorVerified
  }

  beforeMount () {
    this.updateKycPDF()
  }
}
